module.exports = __webpack_public_path__ + "static/image/history/m/202204@3x.jpg?91214325";